import store from '@/store/index'

const settingsService = {
  settings: {
    common: {
      perPage: 30,
      defaultQuantityBeneficiaries: 25,
      defaultQuantityBeneficiariesSvo: 25,
      get personal_account_url() {
        return store.state.app.settings?.personal_account_url ?? 'https://lk.ticket-place.ru'
      },
      get password_min_length() {
        return store.state.app.settings?.password_min_length ?? 8
      },
      get password_max_length() {
        return store.state.app.settings?.password_max_length ?? null
      },
      get regexp_password_special_characters() {
        return store.state.app.settings?.regexp_password_special_characters ?? '!@#$%^&*()-_=+[]{}|;|:\'",.<>/?`~'
      },
      get regexp_password_symbols() {
        return store.state.app.settings?.regexp_password_symbols ?? 'a-zA-z0-9'
      },
      get event_benefit_list() {
        return store.state.app.settings?.event_benefit_list ?? []
      },
      get date_format() {
        return 'DD.MM.YYYY'
      },
      get date_time_format() {
        return 'DD.MM.YYYY HH:mm'
      },
      get date_month_string_format() {
        return 'DD MMMM YYYY'
      },
    },
  },
  getSettings(key = null, defaultValue = null) {
    if (!key) {
      return this.settings
    }

    const keys = key.split('.')
    const result = keys.reduce((acc, k) => (acc === undefined ? undefined : acc[k]), this.settings)

    return result === undefined ? defaultValue : result
  },
}

export default settingsService
